const en = {
    header:{
        home: "Home"
    }
}

export default  en ;